import React from 'react';
import { FileEarmarkText } from 'react-bootstrap-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface SemanticBreadcrumbProps {
  sourceId: string;
  fileName: string;
  excerpt?: string;
  onClick?: (sourceId: string) => void;
}

const SemanticBreadcrumb: React.FC<SemanticBreadcrumbProps> = ({
  sourceId,
  fileName,
  excerpt,
  onClick,
}) => {
  const tooltipContent = excerpt ? `${fileName}\n\n${excerpt}` : fileName;

  const handleClick = () => {
    onClick?.(sourceId);
  };

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={`breadcrumb-${sourceId}`} style={{ whiteSpace: 'pre-wrap' }}>
          {tooltipContent}
        </Tooltip>
      }
    >
      <span
        className="semantic-breadcrumb d-inline-flex align-items-center gap-1"
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        onClick={handleClick}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(); }}
        style={{
          fontSize: '0.7rem',
          color: 'var(--bs-secondary)',
          cursor: onClick ? 'pointer' : 'default',
        }}
      >
        <FileEarmarkText size={11} />
        <span style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {fileName}
        </span>
      </span>
    </OverlayTrigger>
  );
};

export default SemanticBreadcrumb;
